// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/swipe/index.css
// module id = 187
// module chunks = 1